import { getOptimizedImageUrl } from '../../utils/optimizedImages';
import React from 'react';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import { FaRegClock, FaLandmark, FaMosque, FaFlag } from 'react-icons/fa';
import CustomSlider from '../../components/Slider/CustomSlider';

const staticSlides = Array.from({ length: 11 }, (_, i) => ({
  id: i + 1,
  image: getOptimizedImageUrl(`/assets/images/iskenderun-tarihi/tarih-${i + 1}.jpg`),
  title: `İskenderun Tarihi ${i + 1}`,
  description: '',
  guid: `static-${i + 1}`
}));

const History = () => {
  return (
    <div className="history-page">
      <div className="container py-5">
        <div className="row">
          <QuickMenu />
          
          <div className="col-md-10">
            <div className="history-content">
              <h1 className="page-title">İskenderun Tarihi</h1>
              <div className="slider-box" style={{ marginBottom: '2rem' }}>
                <CustomSlider 
                  slides={staticSlides}
                  linkPrefix="/iskenderun-tarihi"
                  settings={{
                    dots: false,
                    infinite: true,
                    autoplay: true,
                    arrows: true,
                    swipe: true,
                    swipeToSlide: true,
                    autoplaySpeed: 3000
                  }}
                />
              </div>
              <div className="timeline-section">
                <div className="timeline-item">
                  <div className="timeline-icon">
                    <FaRegClock />
                  </div>
                  <div className="timeline-content">
                    <h2>Tarih Öncesi Dönem</h2>
                    <p>
                      İskenderun'un kuruluşu, tarih öncesi dönemlere dayanmaktadır. Karaağaç mıntıkasında yer alan Telli köyü adını taşıyan höyükte, Mc. Evan tarafından bulunan bazı çömlek parçaları, buranın antik çağ öncesi yerleşim alanı olduğunu göstermektedir.
                    </p>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-icon">
                    <FaLandmark />
                  </div>
                  <div className="timeline-content">
                    <h2>Milattan Önceki Dönem</h2>
                    <p>
                      MÖ 2000'li yıllarda, bu bölgede Hititler'e bağlı Kadu Beyliği'nin kurulduğu bilinmektedir. "Kadu" kelimesi, Hititçe'de "körfez" anlamına gelmektedir. MÖ 1200'lü yıllardan önce Fenikeliler, bu bölgede "Myriaydus" adıyla bir koloni kurmuşlardır.
                    </p>
                    <p>
                      MÖ 7. yüzyılda Türk asıllı bir millet olan Hurriler'in eline geçen İskenderun ve çevresi, MÖ 6. yüzyılda Perslerin egemenliğine girmiştir. Gerçek anlamda İskenderun, MÖ 333'te, Asya Seferi'ni gerçekleştiren Büyük İskender tarafından kurulmuştur. O dönemde şehre verilen ad ise "Alexandreia"dır.
                    </p>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-icon">
                    <FaLandmark />
                  </div>
                  <div className="timeline-content">
                    <h2>Roma Dönemi ve Sonrası</h2>
                    <p>
                      Roma hâkimiyeti altına girdikten sonra, İranlıların istilasına uğrayan İskenderun'un kalesi tahrip edilip yeniden inşa edilmiştir. Bu dönemde şehrin adı, Peutinger Tabuları'nda Alexandreia Scabiasa olarak geçmektedir.
                    </p>
                    <p>
                      4. yüzyıldan itibaren şehir "Küçük İskenderiye" olarak da anılmaya başlanmıştır. Roma sonrası dönemde, kale muhtemelen Abbâsî Halifesi tarafından yeniden inşa ettirilmiştir.
                    </p>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-icon">
                    <FaMosque />
                  </div>
                  <div className="timeline-content">
                    <h2>Osmanlı Dönemi</h2>
                    <p>
                      Osmanlı yönetiminde, İskenderun ve çevresi 1607 yılında, Sadrazam Kuyucu Murat Paşa ile Celali Canbolatoğlu arasında Oruç Ovası'nda meydana gelen savaş nedeniyle hareketli olaylara sahne olmuştur.
                    </p>
                    <p>
                      17. yüzyılın başlarında Halep Valisi Nasuh Paşa, bugünkü Varyant Yolu'nun Güzün Deresi kanalının kesişim noktasında bulunan kalenin inşaatına başlamıştır. Aynı dönemde İskenderun, Osmanlı İmparatorluğu döneminde ticaret ve stratejik özelliklerini artırarak sürdürmüştür.
                    </p>
                    <p>
                      1872 depremi, İskenderun'da büyük hasara yol açmış, 1881'de Maliye Müfettişi Mesut Bey, şehrin bayındırlık raporunu hazırlayarak maliye nezaretine sunmuştur. Bu rapor doğrultusunda, demir yolunun İskenderun'a bağlanması kararlaştırılmış, liman genişletilmiş ve İskenderun-Halep karayolu inşasına başlanmıştır.
                    </p>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-icon">
                    <FaFlag />
                  </div>
                  <div className="timeline-content">
                    <h2>Fransız İşgali</h2>
                    <p>
                      I. Dünya Savaşı sonrası, Fransa'nın Ortadoğu'daki nüfuz bölgesine dahil edilen İskenderun Sancağı, Türkiye'nin diplomasi tarihinin önemli bir kısmını oluşturan Hatay'ın Anavatan'a katılması sürecinde kritik bir rol oynamıştır.
                    </p>
                    <p>
                      Sancak, Milli Mücadele sırasında Türkiye ile Fransa arasında 20 Ekim 1921'de imzalanan Ankara İtilafnamesi ile Türk toprakları dışında bırakılmıştı. Ancak, Atatürk'ün önderliğindeki mücadelenin ardından bu mesele yeniden gündeme gelmiş ve Hatay, önce bağımsızlık kazanarak, ardından Anavatan'a katılmıştır.
                    </p>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-icon">
                    <FaFlag />
                  </div>
                  <div className="timeline-content">
                    <h2>Hatay Devleti'nin Kurulması ve Anavatana Katılması</h2>
                    <p>
                      Fransa'nın, 1936'da Suriye'ye bağımsızlık vermesinin ardından Türk hükümetinin yoğun müdahaleleri sonucunda Hatay Devleti kurulmuş, aynı gün Hatay Meclisi yasama çalışmalarına başlamıştır.
                    </p>
                    <p>
                      Bir yıl sonra Hatay Meclisi, Hatay'ın Anavatan'a katılması kararını almış ve 5 Temmuz 1938'de Türk Ordusu İskenderun'a girmiştir. Bu olay, Türk tarihinde büyük bir zafer olarak kaydedilmiştir.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;
